import React, { PureComponent } from 'react';
import { Button, message, Modal, Upload, Progress, Spin } from 'antd-v5';
import { UploadOutlined } from '@ant-design/icons';
import { generalParamsWithPToStr } from '../../../utils/math';
import { API_ADMIN } from '../../../utils/urls';
import request from '../../../utils/request';
import { getImportProgressRequest } from '../../../state/request/payEntryData';

const STATUS_ENUM = {
  UPLOADED: 'UPLOADED',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};
class ImportResult extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      importResultVisible: false,
      errorVisible: false,
      errorMessageList: [],
      loading: false,
      data: {},
      taskId: '',
      pollingTimer: null,
    };
  }

  beforeUpload = (file) => {
    this.setState({ loading: true });
    const checkSize = file.size / 1024 / 1024 < 20;
    if (!checkSize) {
      message.error('单个文件不能超过20M!');
      this.setState({ loading: false });
    }
    return checkSize;
  };

  // 开始轮询任务进度
  startPolling = (taskId) => {
    this.setState({ taskId, data: {}, importResultVisible: true });
    this.pollingTimer = setInterval(() => {
      this.pollTaskProgress(taskId);
    }, 500); // 每0.5秒轮询一次
  };

  // 停止轮询
  stopPolling = () => {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
  };

  // 轮询任务进度
  pollTaskProgress = async (taskId) => {
    try {
      const response = await getImportProgressRequest({ taskId });
      const { code, data = {} } = response;
      if (code !== 200) {
        return;
      }
      const { status, successCount } = data;
      const { onRefresh } = this.props;
      this.setState({ data });
      if (status === STATUS_ENUM.COMPLETED) {
        this.stopPolling();
        Modal.success({
          title: `导入成功，成功${successCount}条`,
        });
        onRefresh?.();
        this.setState({ importResultVisible: false });
      } else if (status === STATUS_ENUM.FAILED) {
        this.stopPolling();
        onRefresh?.();
        this.setState({
          importResultVisible: false,
          errorVisible: true,
        });
      }
    } catch (error) {
      this.stopPolling();
      this.setState({ importResultVisible: false });
    }
  };

  // 组件卸载时清理定时器
  componentWillUnmount() {
    this.stopPolling();
  }

  render() {
    const { importResultVisible, errorVisible, loading, data = {} } = this.state;
    const {
      processedRecords = 0,
      estimateTotalRecords = 0,
      errorMessageList = [],
      successCount = 0,
      failCount = 0,
    } = data;
    const { visible, onClose } = this.props;

    const uploadContractProps = {
      className: 'uploader',
      accept: '.xls,.xlsx',
      name: 'file',
      listType: 'picture-card',
      action: `${API_ADMIN}payEntryData/summary/importData?${generalParamsWithPToStr(
        `payEntryData/summary/importData`,
        {},
      )}`,
      headers: {},
      beforeUpload: this.beforeUpload,
      showUploadList: false,
      maxCount: 1,
      customRequest: (options) => {
        const params = { file: options.file };
        this.setState({ loading: true });
        request({ url: options.action, params, headers: 'form-data', method: 'post' }).then(
          (res) => {
            this.setState({ loading: false });
            const { code, data } = res;
            if (code === 200) {
              onClose();
              if (data) {
                this.startPolling(data);
              }
            }
          },
        );
      },
    };
    return (
      <>
        <Modal
          title={'导入'}
          visible={visible}
          onOk={() => onClose()}
          onCancel={() => onClose()}
          destroyOnClose
          maskClosable={false}
          footer={[<Button onClick={() => onClose()}>关闭</Button>]}
        >
          <Spin spinning={loading}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Upload {...uploadContractProps}>
                <UploadOutlined />
                <p>点击此处选择文件</p>
              </Upload>
            </div>
          </Spin>
          <div>
            <p>1、仅支持Excel，单个文件不超过20M</p>
            <p>2、确保表格内只有一个工作簿，如果有多个工作簿只有第一个会被处理</p>
          </div>
        </Modal>
        <Modal
          title={null}
          visible={importResultVisible}
          onOk={() => this.setState({ importResultVisible: false })}
          // onCancel={() => this.setState({ importResultVisible: false })}
          destroyOnClose
          footer={null}
        >
          <div style={{ padding: 32 }}>
            <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 12, textAlign: 'center' }}>
              数据导入中，请稍候
            </div>
            <Progress percent={(processedRecords / estimateTotalRecords) * 100} showInfo={false} />
            {estimateTotalRecords ? (
              <div style={{ textAlign: 'center' }}>
                {processedRecords}/{estimateTotalRecords}
              </div>
            ) : null}
          </div>
        </Modal>
        <Modal
          title='导入结果提示'
          visible={errorVisible}
          onOk={() => this.setState({ errorVisible: false })}
          onCancel={() => this.setState({ errorVisible: false })}
          destroyOnClose
          footer={[<Button onClick={() => this.setState({ errorVisible: false })}>关闭</Button>]}
        >
          <h3>导入成功{successCount}条</h3>
          <h3>导入失败{failCount}条，错误信息如下：</h3>
          <div style={{ maxHeight: 360, overflowY: 'scroll' }}>
            {errorMessageList.map((item, index) => {
              return <p key={index}>{item}</p>;
            })}
          </div>
        </Modal>
      </>
    );
  }
}
export default ImportResult;
